import { Tooltip } from 'antd';
import Icon from 'components/icons';
import { TooltipWrapper, tooltipOverlayStyle } from './styles';

interface UserRowTooltipProps {
  message: string;
  iconFill?: string;
  ariaLabel?: string;
}

const UserRowTooltip = ({
  message,
  iconFill = 'var(--error, #FE6D6D)',
  ariaLabel = 'Assignment failed',
}: UserRowTooltipProps) => {
  return (
    <Tooltip
      title={message}
      placement="right"
      overlayInnerStyle={tooltipOverlayStyle}
      zIndex={10000}
    >
      <TooltipWrapper role="img" aria-label={ariaLabel}>
        <Icon icon="Info" fill={iconFill} size="small" />
      </TooltipWrapper>
    </Tooltip>
  );
};

export default UserRowTooltip;
